import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useSnackbarStore = defineStore('SnackbarInfo', () => {
  const initColor = '';
  const initMessage = '';
  const initTimeout = -1;
  const initActive = false;

  const color = ref(initColor);
  const timeout = ref(initTimeout);
  const message = ref(initMessage);
  const active = ref(initActive);

  const setSnackbar = (newMessage, newColor = 'success', newTimeout = -1) => {
    color.value = newColor;
    timeout.value = newTimeout;
    message.value = newMessage;
    active.value = true;
  };

  const resetSnackbar = () => {
    color.value = initColor;
    timeout.value = initTimeout;
    message.value = initMessage;
    active.value = initActive;
  };

  return {
    color,
    timeout,
    message,
    active,
    setSnackbar,
    resetSnackbar,
  };
});
